import { FC } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { NoteCellViewModel } from './viewModel';
import { IconButton } from '@mui/material';
import { NoteIcon } from '../../../../../lib/icons';

type Props = GridRenderCellParams<NoteCellViewModel>;

export const NoteCell: FC<Props> = ({ value: viewModel }) => {
  return (
    <IconButton
      onClick={(e) => viewModel?.onClick(e)}
      disabled={viewModel?.disabled}
      sx={{ padding: 0 }}
    >
      <NoteIcon sx={{ opacity: !viewModel?.disabled ? '1' : '.3' }} />
    </IconButton>
  );
};
